import { env } from "@/configs/env";
import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";

export type ComponentStatus = "up" | "down";

/** Infratuzilma holatining suratlari (DB, Redis, MinIO). */
export interface HealthReport {
  status: "ok" | "degraded";
  uptime: number;
  timestamp: string;
  services: {
    database: ComponentStatus;
    redis: ComponentStatus;
    minio: ComponentStatus;
  };
}

// `/health` `/api/v1` prefiksidan TASHQARIDA turadi, shuning uchun manzil
// hostgacha qisqartiriladi. Qiymat `@/configs/env` dan keladi — u berilmagan
// holatda ham har doim satr qaytaradi, ya'ni bu yerda `.replace` yiqilmaydi.
export const HEALTH_URL = `${env.API_BASE_URL.replace(/\/api\/v1\/?$/, "")}/health`;

export class HealthApi extends BaseApi {
  // Toast'siz: so'rov har 15 soniyada o'zi takrorlanadi va yiqilganini
  // sahifaning o'zi sababi bilan ko'rsatadi. Backend o'chsa, toast har
  // tekshiruvda ustma-ust yig'ilib, ekranning yarmini yopib qo'yardi.
  getHealth() {
    return this.request.get<HealthReport, ApiResponse<HealthReport>>(HEALTH_URL, {
      skipErrorToast: true,
    });
  }
}

export const healthApi = new HealthApi();
